<template>
  <div class="login-warp">
    <top-nav-menu>
      <div>
        <template v-for="item in menuList">
          <router-link
            v-if="item.target === 'self'"
            :class="['menu-item']"
            :key="item.name"
            :to="item.path"
            >{{ item.name }}</router-link
          >
          <a
            class="menu-item"
            v-else-if="item.target === 'blank'"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </template>
      </div>
    </top-nav-menu>
    <div class="main">
      <div class="left-menu">
        <div :class="['m-menu', { active: isMain }]" @click="toMain">
          <img class="m-menu-icon" src="@/assets/image/10.png" />
          控制台
        </div>
        <Menu
          class="cc-menu"
          ref="Menu"
          :open-names="openName"
          :active-name="activeName"
          accordion
          @on-open-change="openChange"
        >
          <Submenu :name="item.name" v-for="item in leftMenu" :key="item.title">
            <template slot="title">
              <img class="m-menu-icon" :src="item.icon" />
              <!-- <Icon type="ios-paper" /> -->
              <p>{{ item.title }}</p>
            </template>
            <MenuItem
              :name="item2.name"
              v-for="item2 in item.children"
              :key="item2.title"
              :to="item2.path"
              >{{ item2.title }}</MenuItem
            >
          </Submenu>
          <!-- <Submenu name="2">
            <template slot="title">
              <Icon type="ios-people" />
              财务管理
            </template>
            <MenuItem name="2-1">账户信息</MenuItem>
            <MenuItem name="2-2">资金明细</MenuItem>
            <MenuItem name="2-3">发票管理</MenuItem>
          </Submenu>
          <Submenu name="3">
            <template slot="title">
              <Icon type="ios-people" />
              账户管理
            </template>
            <MenuItem name="3-1">个人资料</MenuItem>
            <MenuItem name="3-2">安全中心</MenuItem>
            <MenuItem name="3-3">实名认证</MenuItem>
            <MenuItem name="3-3">登录日志</MenuItem>
          </Submenu> -->
        </Menu>
      </div>
      <div class="right">
        <router-view></router-view>
        <!-- <slot></slot> -->
      </div>
    </div>
    <div>
      <!-- <div class="foot-nav">
        <div class="foot-nav-warp">
          <a
            class="link"
            v-for="item in navList"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </div>
      </div> -->
      <div class="foot-bar">
        <div class="foot-bar-warp">
          <div class="foot-section1">
            <div class="foot-section-text">
              <img
                style="width: 12px; height: 12px"
                src="@/assets/image/6.png"
                alt=""
              />
              甘肃云创空间网络科技有限公司
              <a
                href="http://beian.miit.gov.cn"
                target="_blank"
                style="color: #e9ecf0"
                >陇ICP备2021000911号</a
              >
            </div>
            <div class="foot-section-text">
              甘肃省兰州市城关区张掖路街道通渭路137号2单元803室
            </div>
          </div>
          <div class="foot-section2">
            <div class="foot-section-text">
              <img
                style="width: 12px; height: 12px; margin-right: 5px"
                src="@/assets/image/7.png"
                alt=""
              />
              客服、投诉电话：400-606-1027
            </div>
            <div class="foot-section-text">
              互联网域名服务许可证：
              <a
                href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/甘肃云创空间网络科技有限公司"
                rel="nofollow"
                target="_blank"
                style="color: #e9ecf0"
                >甘D3-20220001</a
              >
            </div>
            <div class="foot-section-text"></div>
          </div>
          <div class="foot-section3">
            <!-- &nbsp; -->
            <div class="foot-section-text">
              <img
                style="width: 12px; height: 12px; margin-right: 5px"
                src="@/assets/image/8.png"
                alt=""
              />
              客服、投诉邮箱：kfdomain@yc0597.com
            </div>
            <div class="foot-section-text">
              .cn .中国域名投诉举报处理平台 电话：010-58813000 邮箱：service@cnnic.cn
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNavMenu from "components/topNavMenu";

export default {
  name: "layout",
  components: {
    topNavMenu,
  },
  data() {
    return {
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "网站建设",
          path: "http://hhzh.net/case_complex.aspx?nid=4",
          target: "blank",
        },
        {
          name: "解决方案",
          path: "http://hhzh.net/case_complex.aspx?nid=4",
          target: "blank",
        },
        {
          name: "新闻资讯",
          path: "http://hhzh.net/news_complex.aspx?nid=2",
          target: "blank",
        },
        {
          name: "招聘职位",
          path: "http://hhzh.net/job.aspx?nid=11",
          target: "blank",
        },
      ],
      // 左侧导航栏
      openName: [],
      // 选中的导航栏
      activeName: "",
      leftMenu: [
        {
          title: "域名管理",
          icon: require("@/assets/image/11.png"),
          name: "domain",
          children: [
            {
              title: "我的域名",
              name: "domain-myDomain",
              path: "/customer/domain",
            },
            {
              title: "我的模板",
              name: "domain-myTemplate",
              path: "/customer/template",
            },
            {
              title: "我的转出",
              name: "domain-transferout",
              path: "/customer/transferout",
            },
            {
              title: "我的转入",
              name: "domain-transferin",
              path: "/customer/transferin",
            },
            {
              title: "域名PUSH",
              name: "domain-push",
              path: "/customer/push",
            },
            {
              title: "域名订单",
              name: "domain-order",
              path: "/customer/order",
            },
          ],
        },
        {
          title: "资金管理",
          icon: require("@/assets/image/12.png"),
          name: "finance",
          children: [
            {
              title: "账户信息",
              name: "finance-account",
              path: "/customer/finance/account",
            },
            {
              title: "资金明细",
              name: "finance-capitaldetails",
              path: "/customer/finance/capitaldetails/index",
            },
          ],
        },
        {
          title: "账户管理",
          icon: require("@/assets/image/13.png"),
          name: "account",
          children: [
            {
              title: "个人资料",
              name: "account-account",
              path: "/customer/account/",
            },
            {
              title: "安全中心",
              name: "account-security",
              path: "/customer/account/security",
            },
            {
              title: "我的认证",
              name: "account-certified",
              path: "/customer/account/certified",
            },
            {
              title: "站内信",
              name: "account-mail",
              path: "/customer/account/mail",
            },
             {
              title: "登录日志",
              name: "account-journal",
              path: "/customer/account/journal",
            },
          ],
        },
      ],
      // isMain: false,
    };
  },
  computed: {
    isMain() {
      return this.$route.name === "customer";
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.openName = [val.meta.submenu];
          this.activeName = val.meta.menuItem;
          this.$nextTick(() => {
            this.$refs.Menu.updateOpened();
            this.$refs.Menu.updateActiveName();
          });
          // }
        }
      },
    },
  },
  methods: {
    toMain() {
      this.$router.push("/customer");
    },
    openChange(event) {
      // 获取当前打开主菜单的所有子菜单
      if (event.length > 0) {
        const checkData = this.leftMenu.filter((o) => o.name === event[0]);
        // 防止重复跳转路由
        if (this.$route.path !== checkData[0].children[0].path) {
          this.$router.replace({ path: checkData[0].children[0].path });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.m-menu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 14px 24px;
  width: 180px;
  height: 50px;
  // border: 1px solid #ffffff1a;
  // border-radius: 30px;
  margin: 0 auto 20px;
  cursor: pointer;
  color: #61677f;
  font-weight: 600;
  font-size: 14px;
}
.m-menu-icon {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}
.m-menu.active {
  background-color: #3964af;
  color: #fff;
}
.login-warp {
  position: relative;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  // min-height: 100vh;
  display: flex;
  flex-direction: column;
  .menu-item {
    color: #fff;
    line-height: 60px;
    font-weight: 400;
    font-size: 16px;
    margin-right: 40px;
  }
}
.foot-nav {
  display: flex;
  align-items: center;
  background-color: #315491;
  height: 100px;
  padding-top: 40px;
  .foot-nav-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .link {
      width: 120px;
      height: 45px;
      line-height: 45px;
      border-radius: 5px;
      border: 1px solid #759de6;
      text-align: center;
      font-size: 14px;
      color: #fff;
      font-weight: 400;
    }
    .link.active {
      color: #fff;
      background-color: #3992e9;
      border-color: #3992e9;
    }
  }
}
.foot-bar {
  min-width: 1200px;
  background-color: #315491;
  // border-top: 1px solid #ffffff1a;
  .foot-bar-warp {
    width: 1250px;
    margin: 0 auto;
    display: flex;
    padding-top: 20px;
    padding-bottom: 40px;
    .foot-section-text {
      font-weight: 400;
      font-size: 14px;
      color: #e9ecf0;
      &:nth-child(n + 2) {
        margin-top: 25px;
      }
    }
    .foot-section1 {
      flex: 2
    }
    .foot-section2 {
      margin-left: 20px;
      flex: 1.5
    }
    .foot-section3 {
      flex: 2.5;
      justify-content: space-between;
      margin-left: 20px;
      .customer {
        margin-top: 21px;
        width: 110px;
        text-align: center;
        height: 46px;
        line-height: 46px;
        color: #e9ecf0;
        cursor: pointer;
      }
    }
  }
}
.main {
  flex: 1;
  min-width: 1200px;
  padding-top: 90px;
  display: flex;
  background-color: #f5f9fe;
  .left-menu {
    padding-top: 60px;
    width: 260px;
    min-height: 600px;
    margin: 0 auto;
    background-color: #fff;
  }
  .right {
    flex: 1;
  }
}
/deep/ .cc-menu {
  width: 180px !important;
  background-color: transparent;
  margin: 0 auto;
  .ivu-menu-opened {
    padding-bottom: 30px;
    .ivu-menu-submenu-title {
      background-color: #3964af;
      color: #fff;
      display: flex;
    }
    .ivu-icon-ios-arrow-down {
      display: none;
    }
  }
  .ivu-menu-item-selected {
    position: relative;
    &::before {
      content: "";
      display: inline-block;
      margin-right: 20px;
      position: absolute;
      width: 5px;
      height: 5px;
      background: #3964af;
      border-radius: 50%;
      left: 30px;
      top: 22px;
    }
    color: #61677f;
    // border-bottom: 1px solid #ffffff1a;
  }
  .ivu-menu-submenu-title {
    color: #61677f;
    // border-radius: 30px;
    // border: 1px solid #ffffff1a;
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 14px;
    display: flex;
  }
  .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: transparent;
    &::after {
      width: 0;
    }
  }
  &::after {
    width: 0;
  }
}
/deep/.ivu-menu-submenu-title-icon {
  transform: rotate(270deg);
  margin-top: -9px;
}
</style>
